import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICommand } from '@workbuddy/ui/model';
import { ButtonComponent, ButtonSplitComponent } from '@workbuddy/ui/v2/components/button';
import { SettingsPanelSplitButton } from '../model';

@Component({
  selector: 'settings-panel-page',
  standalone: true,
  imports: [CommonModule, ButtonComponent, ButtonSplitComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './settings.panel.page.component.html',
  host: {
    'class': 'settings-panel-page',
    '[class.has-back]': '$showBack()',
    '[class.no-header]': '$hideHeader()',
    '[class.no-footer]': '!$hasFooter()',
  },
})
export class SettingsPanelPageComponent {

  public $title = input<string>('', { alias: 'title' });
  public $showBack = input<boolean>(false, { alias: 'showBack' });
  public $showClose = input<boolean>(false, { alias: 'showClose' });
  public $hideHeader = input<boolean>(false, { alias: 'hideHeader' });
  public $headerCommands = input<ICommand[]>([], { alias: 'headerCommands' });
  public $footerLeftCommands = input<ICommand[]>([], { alias: 'footerLeftCommands' });
  public $footerRightCommands = input<ICommand[]>([], { alias: 'footerRightCommands' });
  public $footerSplitButton = input<SettingsPanelSplitButton | undefined>(undefined, { alias: 'footerSplitButton' });

  protected $hasFooter = computed(() => !!this.$footerLeftCommands().length || !!this.$footerRightCommands().length || !!this.$footerSplitButton());

  public back = output<void>();
  public close = output<void>();
}
